import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, input, type OnInit, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { ToastVariant } from ':core/services/toast.service';
import { SvgIcon } from ':shared/enums';

export enum ToastDuration {
    SHORT = 'short',
    MEDIUM = 'medium',
    LONG = 'long',
}

@Component({
    selector: 'app-toast-item',
    templateUrl: './toast-item.component.html',
    styleUrls: ['./toast-item.component.scss'],
    imports: [NgClass, MatIconModule, NgTemplateOutlet],
})
export class ToastItemComponent implements OnInit {
    type = input.required<ToastVariant>();
    duration = input.required<ToastDuration>();
    message = input<string>('');
    dismiss = output<boolean>();

    readonly ToastVariant = ToastVariant;
    readonly SvgIcon = SvgIcon;

    svgIcon = '';

    onClick(): void {
        this.dismiss.emit(true);
    }

    ngOnInit(): void {
        const durationMap = {
            [ToastDuration.SHORT]: 3000,
            [ToastDuration.MEDIUM]: 6000,
            [ToastDuration.LONG]: 9000,
        };
        setTimeout(() => {
            this.dismiss.emit(true);
        }, durationMap[this.duration()]);

        this.svgIcon = this._getSvgIcon();
    }

    private _getSvgIcon(): SvgIcon {
        switch (this.type()) {
            case ToastVariant.SUCCESS:
                return SvgIcon.CHECK;
            case ToastVariant.WARN:
                return SvgIcon.MINUS;
            case ToastVariant.ERROR:
                return SvgIcon.CROSS;
        }
    }
}
